// extracted by mini-css-extract-plugin
export default {"filterContainer":"styles_filterContainer__UZGnE","description":"styles_description__czinr"};